// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2z8Kz","search":"Settings_search__1kKXD","filter":"Settings_filter__3xuCo"};